module.exports = __webpack_public_path__ + "static/media/Project1_Fig13.f3b788c0.svg";